import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('click', '.shoppable-description__link--more', function () {
    const $partialText = $(this).closest('.shoppable-description__partial-text');
    $partialText.hide();
    $partialText.next('.shoppable-description__full-text').show();

    return false;
  });

  $(document).on('click', '.shoppable-description__link--less', function () {
    const $fullText = $(this).closest('.shoppable-description__full-text');
    $fullText.hide();
    $fullText.prev('.shoppable-description__partial-text').show();

    return false;
  });
});
